// Client-side password generator for the Create Team Member modal (CLE-216).
// The backend also generates one when none is supplied; this lets the admin see
// and copy a strong password up-front. Mirrors the backend strength rule:
// >= 8 chars, at least one uppercase letter and one digit.

const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ'; // no I/O for legibility
const LOWER = 'abcdefghijkmnopqrstuvwxyz'; // no l
const DIGITS = '23456789'; // no 0/1
const SYMBOLS = '!@#$%^&*?';
const ALL = UPPER + LOWER + DIGITS + SYMBOLS;

function pick(set: string): string {
  const arr = new Uint32Array(1);
  crypto.getRandomValues(arr);
  return set[arr[0] % set.length];
}

/** Generate a strong random password (length >= 12). */
export function generatePassword(length = 14): string {
  const len = Math.max(length, 8);
  // Guarantee the strength requirements, then fill the rest randomly.
  const required = [pick(UPPER), pick(LOWER), pick(DIGITS), pick(SYMBOLS)];
  const rest: string[] = [];
  for (let i = required.length; i < len; i += 1) rest.push(pick(ALL));
  const chars = [...required, ...rest];
  // Fisher-Yates shuffle so the required chars are not always at the front.
  for (let i = chars.length - 1; i > 0; i -= 1) {
    const j = new Uint32Array(1);
    crypto.getRandomValues(j);
    const k = j[0] % (i + 1);
    [chars[i], chars[k]] = [chars[k], chars[i]];
  }
  return chars.join('');
}

const STRONG_RE = /^(?=.*[A-Z])(?=.*\d).{8,}$/;

/** True when the password meets the backend strength rule. */
export function isStrongPassword(pw: string): boolean {
  return STRONG_RE.test(pw);
}
